import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import { renderColumns } from "./constants";
import { TiUser } from "react-icons/ti";
import Select from "react-select";
import {
  CanAccess,
  AuthorizationList,
} from "../../components/template/authorization/Authorization";
import Swal from "sweetalert2";

const ListStorage = () => {
  const [id, setId] = useState();
  const [storageName, setStorageName] = useState();
  const [outletList, setOutletList] = useState([]);
  const [outletId, setOutletId] = useState();
  const [storageLocation, setStorageLocation] = useState();
  const [records, setRecords] = useState([]);
  const [totalRecord, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [modalAdd, setModalAdd] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    getData();
    getOutlets();
  }, []);

  const handleSubmit = (id = null, isDelete = false, name) => {
    setSubmitting(true);

    let data = {
      name: storageName,
      outlet_id: outletId,
      address:
        outletList.find((value) => value.value === outletId)?.address || "",
    };

    if (IsEmpty(id)) {
      let url = `${process.env.REACT_APP_BASE_API_URL}storage`;
      httpclient
        .POST(url, data)
        .then((response) => {
          console.log(response);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
          setModalAdd(false);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}storage/${id}`;
      if (isDelete === true) {
        Swal.fire({
          title: "Hapus Data",
          text: "Apakah anda yakin ingin menghapus storage " + name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Hapus",
          cancelButtonText: "Batal",
        }).then((result) => {
          if (result.isConfirmed) {
            httpclient
              .DELETE(url)
              .then((response) => {
                SwalToast.fire({
                  icon: "success",
                  title: response.data.message,
                });
                getData();
              })
              .catch((error) => {
                if (error.response) {
                  console.log(error.response.data.error);
                  SwalToast.fire({
                    icon: "error",
                    title: error.response.data.error.message,
                  });
                } else {
                  console.log(error);
                  SwalToast.fire({
                    icon: "error",
                    title: "Whoops, something went wrong",
                  });
                }
              })
              .finally(() => {
                setSubmitting(false);
              });
          }
        });
      } else {
        httpclient
          .PUT(url, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            window.location.reload(false);
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const handleEdit = (record) => {
    setStorageName(record.name);
    setStorageLocation(record.address);
    setOutletId(record.outlet_id);
    setId(record.id);
    setModalAdd(true);
    setIsEdit(true);
  };

  const handleDelete = (record) => {
    handleSubmit(record.id, true, record.name);
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setStorageName("");
    setStorageLocation("");
    setId("");
  };

  const getData = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}storage?name=${search}&page=${page}&size=${pageSize}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        console.log(response);

        setRecords(response.data.data.items);
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getOutlets = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);

        setOutletList(
          response.data.data.map((item) => ({
            value: item.id,
            label: item.name,
            ...item,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const searchData = (name) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearch(name);
    setSearchTimeout(
      setTimeout(function () {
        getData();
      }, 700)
    );
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Daftar Storage"} />
              <Breadcrumb current={"Storage"} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{records.length}</span> Total
                Storage
              </div>
            </div>
          </div>
          <div className="d-flex pt-3">
            <div className="">
              <p className="m-0">Nama Storage:</p>
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Ketikan Nama Storage"
                onChange={(e) => searchData(e.target.value)}
              />
            </div>
            <div className="ml-2">
              <p className="m-0">Lokasi Storage:</p>
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Ketikan Lokasi"
                onChange={(e) => searchData(e.target.value)}
              />
            </div>

            <CanAccess
              role={AuthorizationList.create_storage}
              yes={
                <div
                  className="ml-auto"
                  onClick={() => {
                    setModalAdd(true);
                    setIsEdit(false);
                  }}
                >
                  <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                    + Tambah Storage
                  </button>
                </div>
              }
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete)}
              data={records}
              loading={loading}
              // handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={`${isEdit ? "Ubah" : "Tambah"} Storage`}
        visible={modalAdd}
        onOk={() => handleSubmit(isEdit ? id : null)}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={() => handleSubmit(isEdit ? id : null)}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Storage :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Nama Storage"
              value={storageName}
              onChange={(e) => setStorageName(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center" style={{ marginTop: 12 }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Lokasi Storage :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Select
              options={outletList}
              onChange={(e) => setOutletId(e.value)}
              value={outletList.find((value) => value.value === outletId) || ""}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListStorage;
